import React, { useState } from "react";

interface QuantitySelectorProps {
  initialValue?: number;
  minValue?: number;
  maxValue?: number;
  onQuantityChange?: (quantity: number) => void;
  className?: string;
}

export const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  initialValue = 0,
  minValue = 0,
  maxValue = 999,
  onQuantityChange,
  className = "",
}) => {
  const [quantity, setQuantity] = useState(initialValue);

  const handleDecrement = () => {
    if (quantity > minValue) {
      const newQuantity = quantity - 1;
      setQuantity(newQuantity);
      onQuantityChange?.(newQuantity);
    }
  };

  const handleIncrement = () => {
    if (quantity < maxValue) {
      const newQuantity = quantity + 1;
      setQuantity(newQuantity);
      onQuantityChange?.(newQuantity);
    }
  };

  return (
    <div className={`flex items-center ${className}`}>
      {/* Minus Button */}
      <button
        onClick={handleDecrement}
        disabled={quantity <= minValue}
        className="flex h-8 w-8 items-center justify-center rounded-l-md border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white"
        aria-label="Decrease quantity">
        <span className="text-sm font-medium">-</span>
      </button>

      {/* Quantity Display */}
      <div className="flex h-8 w-12 items-center justify-center border-t border-b border-gray-200 bg-white">
        <span className="text-sm font-medium text-gray-700">{quantity}</span>
      </div>

      {/* Plus Button */}
      <button
        onClick={handleIncrement}
        disabled={quantity >= maxValue}
        className="flex h-8 w-8 items-center justify-center rounded-r-md border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white"
        aria-label="Increase quantity">
        <span className="text-sm font-medium">+</span>
      </button>
    </div>
  );
};

export default QuantitySelector;
